(() => {
  const MAX_QUANTITY = 3;
  const SELECTOR = 'quantity-input input[type="number"], input[name="quantity"][type="number"]';

  function message() {
    return document.documentElement.lang.toLowerCase().startsWith('ja')
      ? '同じサイズの商品は3枚まで購入できます。'
      : 'You can purchase up to 3 of the same size.';
  }

  function announce(input) {
    input.setCustomValidity(message());
    input.reportValidity();
    window.setTimeout(() => input.setCustomValidity(''), 1500);
  }

  function applyLimit(root = document) {
    const inputs = root.matches?.(SELECTOR) ? [root] : root.querySelectorAll?.(SELECTOR) || [];

    inputs.forEach((input) => {
      input.max = String(MAX_QUANTITY);
      input.dataset.max = String(MAX_QUANTITY);

      if (Number(input.value) > MAX_QUANTITY) {
        input.value = String(MAX_QUANTITY);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  document.addEventListener(
    'input',
    (event) => {
      const input = event.target.closest?.(SELECTOR);
      if (!input || Number(input.value) <= MAX_QUANTITY) return;

      input.value = String(MAX_QUANTITY);
      announce(input);
    },
    true,
  );

  document.addEventListener(
    'submit',
    (event) => {
      const input = event.target.querySelector?.(SELECTOR);
      if (!input || Number(input.value) <= MAX_QUANTITY) return;

      event.preventDefault();
      input.value = String(MAX_QUANTITY);
      announce(input);
    },
    true,
  );

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) applyLimit(node);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyLimit(), { once: true });
  } else {
    applyLimit();
  }

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
